import { User } from "./user";
import { UserRole } from "./userRole";

export class UserRoleDetails {
    user: User;
    role: UserRole;

    constructor() {
    }
    

}